(function () {
  const root = document.documentElement;
  const SECTION_SELECTORS = ['#main-block', '.left-wrapper', '.right-wrapper'];
  const SWIPE_THRESHOLD = 32;

  let touchStartY = null;
  let touchStartScrollY = 0;
  let nestedScroller = null;
  let ignoreGesture = false;

  function isPortraitOrientation() {
    if (window.matchMedia) {
      return window.matchMedia('(orientation: portrait)').matches;
    }
    return window.innerHeight >= window.innerWidth;
  }

  function isStickyScrollActive() {
    return root.classList.contains('desktop-portrait-accepted') &&
      isPortraitOrientation() &&
      !root.classList.contains('desktop-burger-open') &&
      !root.classList.contains('desktop-chart-fullscreen-lock') &&
      !root.classList.contains('desktop-right-chart-fullscreen-lock');
  }

  function isInteractiveChartTarget(target) {
    return root.classList.contains('desktop-chart-interactive') &&
      target instanceof Element &&
      !!target.closest('#main-block .chart-wrapper');
  }

  function getSections() {
    return SECTION_SELECTORS
      .map((selector) => document.querySelector(selector))
      .filter(Boolean)
      .map((el) => ({ el, top: Math.round(el.getBoundingClientRect().top + window.scrollY) }))
      .sort((a, b) => a.top - b.top);
  }

  function findNestedScroller(target) {
    let el = target instanceof Element ? target : null;
    while (el && el !== document.body && el !== root) {
      const overflowY = window.getComputedStyle(el).overflowY;
      if ((overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight - el.clientHeight > 2) {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }

  function nestedCanScroll(el, direction) {
    if (!el) {
      return false;
    }
    if (direction > 0) {
      return el.scrollTop + el.clientHeight < el.scrollHeight - 1;
    }
    return el.scrollTop > 1;
  }

  function getCurrentIndex(sections, scrollY) {
    let index = 0;
    let smallest = Infinity;
    sections.forEach((section, i) => {
      const distance = Math.abs(section.top - scrollY);
      if (distance < smallest) {
        smallest = distance;
        index = i;
      }
    });
    return index;
  }

  function snapToIndex(sections, index) {
    const clamped = Math.max(0, Math.min(sections.length - 1, index));
    const target = clamped === 0 ? 0 : sections[clamped].top;
    window.scrollTo({ top: target, behavior: 'smooth' });
  }

  function onTouchStart(event) {
    if (!isStickyScrollActive() || event.touches.length !== 1) {
      touchStartY = null;
      ignoreGesture = true;
      return;
    }
    ignoreGesture = isInteractiveChartTarget(event.target);
    if (ignoreGesture) {
      touchStartY = null;
      return;
    }
    touchStartY = event.touches[0].clientY;
    touchStartScrollY = window.scrollY;
    nestedScroller = findNestedScroller(event.target);
  }

  function onTouchEnd(event) {
    if (touchStartY === null || ignoreGesture || !isStickyScrollActive()) {
      touchStartY = null;
      return;
    }

    const endTouch = event.changedTouches[0];
    const delta = endTouch ? touchStartY - endTouch.clientY : 0;
    touchStartY = null;

    if (Math.abs(delta) < SWIPE_THRESHOLD) {
      return;
    }

    const direction = delta > 0 ? 1 : -1;
    if (nestedCanScroll(nestedScroller, direction)) {
      return;
    }

    const sections = getSections();
    if (sections.length < 2) {
      return;
    }

    const currentIndex = getCurrentIndex(sections, touchStartScrollY);
    snapToIndex(sections, currentIndex + direction);
  }

  document.addEventListener('touchstart', onTouchStart, { passive: true });
  document.addEventListener('touchend', onTouchEnd, { passive: true });
})();
